import React from 'react';
import { withRouter } from 'react-router-dom';

import Logo from './Logo';
import images from '../Images';
import { Api } from '../rest-api/api-exports';
import localStorage from '../LocalStorage';
import { StaticRoutePaths } from '../ClientRoutes';

import LocalizedStrings from 'react-localization';
import { translations } from '../Translations';

class CreatePasswordPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            token: '',
            password: '',
            secondPassword: '',
            error: false,
            errorMessage: ''
        };
    }

    componentDidMount() {
        let strings = new LocalizedStrings(translations);

        if (localStorage.getFromStorage('lang') === undefined) {
            localStorage.saveInStorage('lang', navigator.language.substring(0, 2));
        }

        strings.setLanguage(localStorage.getFromStorage('lang'));

        const url = this.props.location.search;
        let token = url
            .split('=')
            .splice(1, url.length)
            .join('');
        this.setState({ ...this.state, token: token });
    }

    updatePassword = e => {
        this.setState({ ...this.state, password: e.target.value });
    };

    updateRepeatPassword = e => {
        this.setState({ ...this.state, secondPassword: e.target.value });
    };

    createPasswordHandler = () => {
        if (this.state.password !== '' && this.state.secondPassword !== '') {
            if (this.state.password === this.state.secondPassword) {
                Api.Passwords.create(this.state.token, {
                    password: this.state.password,
                    confirmPassword: this.state.secondPassword
                })
                    .then(() => {
                        this.setState({ ...this.state, error: false, errorMessage: '' });
                        localStorage.removeUsername('username');
                        localStorage.removeToken('token');
                        localStorage.removeToken('refresh_token');
                        localStorage.removeUsernameRole();
                        localStorage.removeFromStorage('expiration_time');
                        this.props.history.push(StaticRoutePaths.LOGIN);
                    })
                    .catch(err => {
                        const error = err.body[0].password.join('');
                        this.setState({ ...this.state, error: true, errorMessage: error });
                    });
            } else {
                this.setState({
                    ...this.state,
                    error: true,
                    errorMessage: "Password doesn't match."
                });
            }
        } else if (this.state.password === '' && this.state.secondPassword === '') {
            this.setState({
                ...this.state,
                error: true,
                errorMessage: 'Please provide password and repeat after that.'
            });
        } else {
            if (this.state.secondPassword === '') {
                this.setState({
                    ...this.state,
                    error: true,
                    errorMessage: 'Please repeat password.'
                });
            }
        }
    };

    errorMessage = (error, errorMsg) => (error ? <div className="Error-message">{errorMsg}</div> : null);

    render() {
        return (
            <div className="container">
                <div className="login-container row" onKeyPress={this.pressEnterHandler}>
                    <div className="col-6 offset-3">
                        <div className="row">
                            <div className="col-12 text-center">
                                <div className="logo">
                                    <Logo url={images.LOGIN_LOGO} />
                                </div>
                            </div>

                            <div className="col-12 text-center">
                                <h1 className="login-title">{this.props.type === 'Create' ? 'SET PASSWORD' : 'RESET PASSWORD'}</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 text-center">
                                <div className="form-container">
                                    <input
                                        className="password-input input"
                                        placeholder="Password"
                                        id="username"
                                        type="password"
                                        onChange={this.updatePassword}
                                    />
                                    <input
                                        className="password-input input"
                                        placeholder="Repeat Password"
                                        id="password"
                                        type="password"
                                        onChange={this.updateRepeatPassword}
                                    />
                                    <span style={{ fontStyle: 'italic', color: '#858585' }}>* Please enter at least 8 characters</span>
                                    {this.errorMessage(this.state.error, this.state.errorMessage)}
                                    <input
                                        className="login-button input"
                                        id="login"
                                        value={this.props.type === 'Create' ? 'Create Password' : 'Reset Password'}
                                        type="submit"
                                        onClick={this.createPasswordHandler}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(CreatePasswordPage);



// WEBPACK FOOTER //
// ./src/customModules/Common/components/Passwords-component.js